import { haversineKm } from './geomath';

// Cumulative distance (km) at each route vertex.
function cumulative(coords) {
  const cum = [0];
  for (let i = 1; i < coords.length; i++) {
    cum[i] = cum[i - 1] + haversineKm(coords[i - 1][1], coords[i - 1][0], coords[i][1], coords[i][0]);
  }
  return cum;
}

// Snap each POI to its nearest route vertex → distance-along (km) + off-route
// (km), sorted by progress along the route.
export function projectAlongRoute(coords, pois, cum) {
  const c = cum || cumulative(coords);
  return (pois || []).map(p => {
    let best = Infinity, km = 0;
    for (let i = 0; i < coords.length; i++) {
      const d = haversineKm(p.lat, p.lng, coords[i][1], coords[i][0]);
      if (d < best) { best = d; km = c[i]; }
    }
    return { ...p, km, offKm: best };
  }).sort((a, b) => a.km - b.km);
}

// Fuel-range planning: longest stretch with no fuel.
// Returns { totalKm, stations:[{km,name,offKm}], maxGap, gapStartKm, gapEndKm }.
export function analyzeFuelRange(coords, fuel) {
  if (!coords || coords.length < 2) return null;
  const cum = cumulative(coords);
  const totalKm = cum[cum.length - 1];
  const stations = projectAlongRoute(coords, fuel, cum);

  const marks = [0, ...stations.map(s => s.km), totalKm];
  let maxGap = 0, gapStartKm = 0, gapEndKm = totalKm;
  for (let i = 1; i < marks.length; i++) {
    const g = marks[i] - marks[i - 1];
    if (g > maxGap) { maxGap = g; gapStartKm = marks[i - 1]; gapEndKm = marks[i]; }
  }
  return { totalKm, stations, maxGap, gapStartKm, gapEndKm };
}
